/** The app mode is a parameter that represents a global mode of operation for the entire system. */
export enum AppMode {
  Retail = 'retail',
  Wholesale = 'wholesale',
}
